import compactDisplays from "../../constants/compactDisplay";
import { REFERENCE_RELATES_TO } from "../../constants/references";

const defaultValues = {
  references: [REFERENCE_RELATES_TO],
  properties: [],
  canHaveDate: false,
  canIncludeInNarrative: false,
  showInSequence: false,
  showOnSidebar: true,
  showAsColumn: true,
  columnIsVisible: true,
  compactDisplay: compactDisplays.SHORT_LABEL,
  canDelete: true,
  enabled: true
};

const getRecessiveValues = v2Type => {
  return {
    id: v2Type.guid,
    canHaveDate: !v2Type.persistent
  };
};

const getDominantValues = v2Type => {
  return {
    label: v2Type.name,
    pluralLabel: v2Type.name,
    identifierPrefix: v2Type.name.toUpperCase().substr(0, 3),
    icon: v2Type.icon,
    color: v2Type.color,
    sortOrder: v2Type.sortOrder
  };
};

export default (v3Type, v2Type) => {
  return Object.assign({}, defaultValues, getRecessiveValues(v2Type), v3Type, getDominantValues(v2Type));
};

// export default v2Type => {
//   return {
//     id: v2Type.guid,
//     label: v2Type.name,
//     references: [],
//     properties: [],
//     canHaveDate: !v2Type.persistent,
//     canIncludeInNarrative: false,
//     showInSequence: false,
//     showOnSidebar: true,
//     showAsColumn: true,
//     hasAvatar: v2Type.name === "Person" || v2Type.name === "Character",
//     identifierPrefix: v2Type.name.toUpperCase().substr(0, 3),
//     canDelete: false,
//     // These values are not part of the standard definition
//     icon: v2Type.icon,
//     color: v2Type.color
//   };
// };
